import { BrowserRouter, Routes, Route } from "react-router-dom";
import { lazy, Suspense } from "react";
import ContactButton from "../Home/ContactButton";

const Dashboard = lazy(() => import("../Home/Dashboard"));
const Training = lazy(() => import("../Pages/Training"));
const Consulting = lazy(() => import("../Pages/Consulting"));

const IntroductionCATIACAA = lazy(() =>
  import("../Blog/Tutorial Articles/IntroductionCATIACAA")
);

const CAAArchitecture = lazy(() =>
  import("../Blog/Tutorial Articles/CAAArchitecture")
);

const ObjectModeler = lazy(() =>
  import("../Blog/Tutorial Articles/ObjectModeler")
);

const WorkbenchDevelopment = lazy(() =>
  import("../Blog/Tutorial Articles/WorkbenchDevelopment")
);

const CATIACAAvsCATScript = lazy(() =>
  import("../Blog/Comparisons/CATIACAAvsCATScript")
);

const CATIACAAvsNXOpen = lazy(() =>
  import("../Blog/Comparisons/CATIACAAvsNXOpen")
);

const CATIACAAvsCreoToolkit = lazy(() =>
  import("../Blog/Comparisons/CATIACAAvsCreoToolkit")
);

const CATIACAAvsSOLIDWORKSAPI = lazy(() =>
  import("../Blog/Comparisons/CATIACAAvsSOLIDWORKSAPI")
);

const PartCreationAutomation = lazy(() =>
  import("../Blog/Automation Project Use Cases/PartCreationAutomation")
);

const AssemblyAutomation = lazy(() =>
  import("../Blog/Automation Project Use Cases/AssemblyAutomation")
);

const DrawingAutomation = lazy(() =>
  import("../Blog/Automation Project Use Cases/DrawingAutomation")
);

const ENOVIAIntegration = lazy(() =>
  import("../Blog/Automation Project Use Cases/ENOVIAIntegration")
);

const BuyLicense = lazy(() =>
  import("../Pages/BuyLicense")
);



function AppRoutes() {
  return (
    <BrowserRouter>
    <Suspense fallback={<div>Loading...</div>}>
      <Routes>
         <Route path="/" element={<Dashboard />} />
          <Route path="/training" element={<Training />} />
           <Route path="/consulting" element={<Consulting />} />
            <Route path="/Introduction to CATIA CAA" element={<IntroductionCATIACAA />} />
             <Route path="/CAA Architecture" element={<CAAArchitecture />} />
              <Route path="/Object Modeler" element={<ObjectModeler />} />
               <Route path="/Workbench Development" element={<WorkbenchDevelopment />} />
                <Route path="/CATIA CAA vs CATScript" element={<CATIACAAvsCATScript />} />
                 <Route path="/CATIA CAA vs NX Open" element={<CATIACAAvsNXOpen />} />
                  <Route path="/CATIA CAA vs Creo Toolkit" element={<CATIACAAvsCreoToolkit />} />
                   <Route path="/CATIA CAA vs SOLIDWORKS API" element={<CATIACAAvsSOLIDWORKSAPI />} />
                    <Route path="/Part Creation Automation" element={<PartCreationAutomation />} />
                     <Route path="/Assembly Automation" element={<AssemblyAutomation />} />
                      <Route path="/Drawing Automation" element={<DrawingAutomation />} />
                       <Route path="/ENOVIA Integration" element={<ENOVIAIntegration />} />
                        <Route path="/BuyLicense" element={<BuyLicense />} />
         
      </Routes>
      <ContactButton />
      </Suspense>
    </BrowserRouter>
  );
}

export default AppRoutes;